module.exports = __webpack_public_path__ + "static/media/Seam_5731.ebd0a895.jpg";